<ms-skeleton-main-mobile *ngIf="device.isMobile && !device.isTablet" [pageName]="pageName"> </ms-skeleton-main-mobile>
<ms-skeleton-main-desktop *ngIf="!device.isMobile || device.isTablet" [pageName]="pageName"> </ms-skeleton-main-desktop>
